<template>
    <div id="own-success-stories">
        <!--=====================================-->
        <!--=          Team  Area Start         =-->
        <!--=====================================-->
        <section class="section">
            <div class="container">
                <div class="section-heading heading-light">
                    <span class="subtitle primary">Casos de éxito</span>
                    <h2 class="mb--50 black font-weight-100">
                        <slot name="title"></slot>
                    </h2>
                </div>
                <div class="row">
                    <div :key="index" v-for="(project, index) in projects" class="col-md-4">
                        <success-card :projectAlias="project.alias" :icon="project.photo" :isPersonal="isPersonal">
                            <template v-slot:list>
                                <ul class="list-style">
                                    <li :key="itemIndex" v-for="(item, itemIndex) in project.item_list"><strong>{{
                                        item.title }} </strong>{{ item.value }}</li>
                                </ul>
                            </template>
                        </success-card>
                    </div>
                    <!-- <startTodayCard id="own-success-stories" /> -->
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import successCard from '../partials/success-card.vue';
import startTodayCard from '../partials/start-today-card.vue';
export default {
    name: "OwnSuccessStories",
    props: ["projects", "isPersonal"],
    components: {
        successCard,
        startTodayCard,
    }
}

</script>

<style>
.container {
    padding: 3rem;
}

#own-success-stories .start-card {
    position: relative;
    top: -12rem;
}

#own-success-stories .start-card {
    width: 40% !important;
    margin-left: auto !important;
    margin-right: 1rem;
}

@media only screen and (max-width: 575px) {
    #own-success-stories .start-card{
        width: 100% !important;
        display: none !important;
    }
}

@media only screen and (max-width: 991px) {
    #own-success-stories .start-card{
        width: 100% !important;
        display: none !important;
    }
}
</style>